import { withRouter } from 'react-router-dom'

import { compose, createSink, fromRenderProps, onlyUpdateForKeys } from 'recompose'

import { APP_VERSION } from 'app-constants'
import defaults from 'components/Trackers/defaults'
import { getPageViewEvent } from 'utils/analytics'
import { getFlow, getFunnelName } from 'utils/FlowProvider/utils'
import { isDynamicFunnelEnabled, retrieveMetadata } from 'utils/FunnelContext/utils'
import { getTierPrice } from 'utils/TieredRegistration/utils'

import trackEvent from './trackEvent'
import { getSourceAttributes } from './utils'
import { UserContext, UserContextProps } from '../../providers/UserProvider'

export type EventData = {
  object_name: string
  screen: string
  screen_name: string
}

const enhance = compose(
  fromRenderProps(UserContext.Consumer, ({ userData }: UserContextProps) => ({
    userData,
  })),
  withRouter,
  onlyUpdateForKeys(['location']),
)

const trackPageViewed = ({ userData, location }) => {
  const flow = getFlow()
  const eventData = getPageViewEvent(location) as EventData
  const tierPrice = getTierPrice()

  if (!eventData || Object.keys(eventData).length === 0) return

  // For consistency with mobile, we send Page Views as tracked screen view events
  trackEvent('Screen Viewed', {
    eventData: {
      ...defaults('Screen Viewed'),
      ...eventData,
      tierPrice,
      sourceAttributes: getSourceAttributes({ flow, location }),
    },
    flow,
  })

  const funnel = isDynamicFunnelEnabled() ? retrieveMetadata().name : getFunnelName(flow)

  window.dataLayer.push({
    event: 'Screen Viewed',
    funnel,
    funnel_pathname: window.location.pathname,
    email: userData?.email,
  })

  window.analytics.page({
    app_version: APP_VERSION,
    url: window.location.href,
    funnel,
    tierPrice,
  })
}

export default enhance(createSink(trackPageViewed))
